export const NAVBAR = 'navbar'
export const TOUR = 'tour'
export const EMAIL = 'email'
export const NOTES = 'notes'
export const EVIDENCE_LOCKER = 'evidence locker'
export const TABLEVIEW = 'tableview'
export const CHAT = 'chat'
export const CUS = 'chatbot update system (CUS)'
export const SURVEY = 'survey'
export const RISK = 'risk assessment'
export const ROLES = 'roles'
export const DASHBOARD = 'dashboard';
export const GAMEBOARD = 'gameboard'
export const CIRT = 'cirt';
export const COLLABORATIVE_EDITOR = 'collaborative editor'
export const INDIVIDUAL_EDITOR = 'individual editor'
export const DOCUMENTATION = 'documentation'
export const VIDEO_CALL = 'video call'
export const TEAM_PROFILE = 'team profile'
export const VIDEO_RECORDER = 'video recorder'
export const FEED = 'feed'
export const CERTIFICATE = 'certificate'
export const ANIMATION = 'animation'
export const LAYOUT = 'layout'
export const RESEARCH_CONSENT = 'research consent'
export const CLICKABLE_MAP = 'clickable map'
export const TERMINAL = 'terminal'
